import React, { useContext, useEffect, useState } from "react";

import close from "../icons/Close.svg";
import { FormContext } from "../providers/formValues";
import { AuthContext } from "../providers/auth";
import { AppDataContext } from "../providers/appData";
import { useHistory, Link } from "react-router-dom";
import { motion } from "framer-motion";
import CurrencyFormat from "../helper/CurrencyFormat";

function CablePlansModal() {
  const { formData, formDispatch } = useContext(FormContext);
  const { user, setShowModal, showModal } = useContext(AuthContext);
  const { appData, dispatch } = useContext(AppDataContext);
  let myNetwork;

  switch (formData.tv) {
    case "DSTV":
      myNetwork = appData.cable_plans.DSTV;
      break;
    case "STARTIMES":
      myNetwork = appData.cable_plans.STARTIMES;
      break;
    case "GOTV":
      myNetwork = appData.cable_plans.GOTV;
      break;
    default:
      myNetwork = "please select a network";
  }
  const inputPlansId = (plan) => {
    formDispatch({
      type: "INPUTVALUES",
      data: { name: "plan", value: plan },
    });

    formDispatch({
      type: "INPUTVALUES",
      data: { name: "plans_id", value: plan.id },
    });
    formDispatch({
      type: "INPUTVALUES",
      data: { name: "plans_name", value: plan.name },
    });

    formDispatch({
      type: "INPUTVALUES",
      data: {
        name: "walletPrice",
        value: (plan.value * plan.wallet_price) / 100,
      },
    });

    formDispatch({
      type: "INPUTVALUES",
      data: { name: "atmPrice", value: (plan.value * plan.atm_price) / 100 },
    });

    setShowModal(false);
  };

  useEffect(() => {
    formDispatch({
      type: "INPUTVALUES",
      data: { name: "plans_id", value: "" },
    });
    formDispatch({
      type: "INPUTVALUES",
      data: { name: "plans_name", value: "" },
    });

    formDispatch({
      type: "INPUTVALUES",
      data: { name: "walletPrice", value: "" },
    });
    formDispatch({
      type: "INPUTVALUES",
      data: { name: "atmPrice", value: "" },
    });
  }, []);
  return (
    <div>
      <div
        className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-40 outline-none focus:outline-none 
      "
      >
        <motion.div
          className="absolute w-full  mx-auto max-w-sm md:max-w-lg top-44 inset-x-0"
          initial={{ opacity: 0.5, y: 500 }}
          animate={{ opacity: [0, 1], y: [500, -50] }}
          transition={{ duration: 0.3, type: "tween" }}
        >
          {}
          {/*content*/}
          <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none p-4">
            {/*header*/}
            <div className="flex py-4 rounded-t-lg">
              <button
                className=" bg-transparent border-0 text-right  outline-none focus:outline-none  h-6 w-5"
                onClick={() => setShowModal(false)}
              >
                <img src={close} alt="close" />
              </button>
              <h3 className="text-lg font-extrabold text-black text-center mx-auto">
                Cable Plans
              </h3>
            </div>
            {/*body*/}
            <div className="relative flex flex-col text-black  mb-5">
              <table className="table p-4 bg-white shadow rounded-lg ">
                <tbody className="bg-secondary-blue">
                  {myNetwork.map((plan) => (
                    <tr
                      className="text-secondary-black  border-b-8 border-white"
                      key={plan.id}
                      onClick={() => {
                        inputPlansId(plan);
                      }}
                    >
                      <td className=" font-medium text-sm p-2">{plan.name}</td>
                      <td className=" p-4 ">
                        <div className=" font-medium text-xx text-primary-gray">
                          Wallet
                        </div>
                        <div className="mt-1">{`₦${CurrencyFormat(
                          plan.value
                        )}`}</div>
                      </td>
                      <td className=" p-1 ">
                        <div className=" font-medium text-xx text-primary-gray">
                          ATM
                        </div>
                        <div className="mt-1">
                          {" "}
                          {`₦${CurrencyFormat(plan.value)}`}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {/*footer*/}
          </div>
        </motion.div>
      </div>
      <div className="opacity-25 fixed inset-0 z-30 bg-black"></div>
    </div>
  );
}

export default CablePlansModal;
